import { makeAutoObservable } from "mobx"
import DraftShareChecklistItem from "./DraftShareChecklistItem"
import DraftShareVersion from "./DraftShareVersion"

export default class DraftShareActionDraft {

  constructor(actionDraft = {}) {
    this.id = actionDraft.id
    this.draft_status = actionDraft.draft_status || 'draft'
    this.due_date = actionDraft.due_date
    this.enabled_fields = actionDraft.enabled_fields || {}
    this.checklist_items = actionDraft.checklist_items?.map(item => new DraftShareChecklistItem(item)) || []
    this.versions = actionDraft.versions?.map(version => new DraftShareVersion(version)) || []

    makeAutoObservable(this)
  }

  fieldEnabled(field) {
    return !!this.enabled_fields[field]
  }

  get latestVersion() {
    return this.versions[this.versions.length - 1] || null
  }

  // The version currently being worked on - the influencer's own in-flight
  // save, if there is one that hasn't been submitted yet.
  get workingVersion() {
    const latest = this.latestVersion
    return latest && !latest.isSubmitted ? latest : null
  }

  // The most recent round the PM actually reviewed - carries the released
  // feedback and per-item pass/fail marks a revision needs to show.
  get latestSubmittedVersion() {
    const submitted = this.versions.filter(v => v.isSubmitted)
    return submitted[submitted.length - 1] || null
  }

  addVersion(version) {
    const existing = this.versions.find(v => v.id === version.id)
    if (existing) {
      Object.assign(existing, version)
    } else {
      this.versions.push(version)
    }
  }
}
